import { render, staticRenderFns } from "./NestingSpace.vue?vue&type=template&id=8e796ae2&scoped=true"
import script from "./NestingSpace.vue?vue&type=script&lang=js"
export * from "./NestingSpace.vue?vue&type=script&lang=js"
import style0 from "./NestingSpace.vue?vue&type=style&index=0&id=8e796ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e796ae2",
  null
  
)

export default component.exports